<template>
  <div class="tw-rounded-t-lg tw-flex-col" style="position: absolute; z-index: 1000; bottom: 0; left: 0; display: flex; width: 100%; background-color: #1f242a;">
    <div v-on:click="closeOverlay" class="tw-flex tw-flex-row-reverse tw-mr-2 tw-mt-1">
      close
    </div>
    <div class="tw-ml-4">
      <div v-if="this.ath.team_id" class="nameoverflow" id="athletename">
          <img v-if="this.ath.country_code" style="height:15px; width:15px;" v-bind:src="getFlag(this.ath)"> {{this.ath.team.name}}
        </div>
      <div v-else-if="this.ath.first_name" class="nameoverflow" id="athletename">
          <img v-if="this.ath.country_code" style="height:20px; width:20px;" v-bind:src="getFlag(this.ath)"> {{this.ath.first_name}} {{this.ath.last_name}} - ({{this.ath.bib_id}})
      </div>
    </div>
    <infoblock v-if="this.athlete"></infoblock>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Infoblock from "./athlete/infoblock";

  export default {
    name: "athleteOverlay",
    mounted () {
    },
    data: function () {
      return {
      }
    },
    watch: {
      '$route': function (to, from) {
      }
    },
    components: {
      Infoblock
    },
    methods: {
      getFlag: function (ath) {
        return ath.country_code === null ? '' : 'https://app.sportraxs.com/images/svg/' + ath.country_code.toLowerCase() + '.svg'
      },
      closeOverlay: function() {
        console.log('close')
        self = this
        if (self.mobile) {
          self.$router.push({name: 'map'})
        }
      }
    },
    computed: {
      ...mapGetters({
        mobile: 'mobile',
        athlete: 'focusedAthlete',
        getAthletes: 'athletes',
        ath: 'athlete'
      }),
      leaderboardheight: function () {
        if (this.mobile) {
          let h = window.innerHeight - 70 - 50 - 60
          return {
            height: h + 'px'
          }
        } else {
          let h = window.innerHeight - 70 - 50 - 53
          return {
            height: h + 'px'
          }
        }
      },
      isAthleteLoaded: function() {
        return Object.keys(this.ath).length !== 0
      }
    },
    created: function () {
      // TODO Matthew - for now as race might not be loaded if directly routed too.
      if (this.getAthletes.length === 0) {
        if (this.mobile) {
          this.$router.push({ name: 'mleaderboard' })
        } else {
          this.$router.push({ name: 'leaderboard' })
        }
      } else {
        this.$store.dispatch('focusAthlete', this.$router.currentRoute.params.id)
      }
      this.$store.dispatch('loadRaceAthlete', this.$router.currentRoute.params.id)
    },
    beforeRouteUpdate (to, from, next) {
      this.$store.dispatch('removeRaceAthlete')
      this.$store.dispatch('loadRaceAthlete', to.params.id)
      next()
    },
    beforeDestroy: function() {
      this.$store.dispatch('removeRaceAthlete')
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/athleteOverlay.vue